export default __webpack_public_path__ + "static/media/rnzcuc-logo.abff6993.png";